import { useEffect, useMemo, useState } from "react";

import Lister from "../../components/Lister/Lister";
import ListerSearch from "../../components/Lister/ListerSearch/ListerSearch";
import { useSession } from "../../contexts/SessionContext";
import { Ephemeral } from "../../models/Ephemeral";
import { formatDateHumanly } from "../../services/TimeService";
import translate from "../../services/Translate";
import { fetchEphemerals } from "./Ephemerals.function";

export const Ephemerals = () => {
  const { language } = useSession();
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [ephemerals, setEphemerals] = useState<Ephemeral[]>([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    fetchEphemerals(setEphemerals, setLoaded, language);
  }, [language]);

  const _filteredItems = useMemo(
    () => ephemerals.filter((item) => Object.values(item).join(" ").toLowerCase().includes(searchQuery.toLowerCase())),
    [ephemerals, searchQuery]
  );

  const columns = [
    { header: translate(language, "PAGES.EPHEMERAL.ID"), key: "ID", sortType: "number" },
    { header: translate(language, "PAGES.EPHEMERAL.NAME"), key: "name", sortType: "string" },
    { header: translate(language, "PAGES.EPHEMERAL.TITLE_COLUMN"), key: "title", sortType: "string" },
    { header: translate(language, "PAGES.EPHEMERAL.CURSUS"), key: "cursus", sortType: "string" },
    {
      header: translate(language, "PAGES.EPHEMERAL.MANDATORY_RATIO"),
      key: "mandatory_ratio",
      sortType: "number",
      render: (item: Ephemeral) => <span>{item.mandatory_ratio}</span>,
    },
    {
      header: translate(language, "PAGES.EPHEMERAL.DEPRECATED"),
      key: "is_deprecated",
      render: (item: Ephemeral) => (
        <div className="text-center">
          {!item.is_deprecated ? (
            <span className="dst-icon-check green-font" />
          ) : (
            <span className="dst-icon-x dark-red-font" />
          )}
        </div>
      ),
    },
    {
      header: translate(language, "PAGES.EPHEMERAL.CREATED_DATE"),
      key: "dt_created",
      sortType: "date",
      render: (item: Ephemeral) => (
        <span title={formatDateHumanly(language, new Date(item.dt_created * 1000).toISOString(), true)}>
          {formatDateHumanly(language, new Date(item.dt_created * 1000).toISOString())}
        </span>
      ),
    },
  ];

  return (
    <div className="m-3">
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex w-fit align-items-center justify-content-between mb-3">
          <h2 className="mb-0 me-3">{translate(language, "PAGES.EPHEMERAL.TITLE")}</h2>
          <ListerSearch setSearchQuery={setSearchQuery} timeDelay={500} showSearchIcon />
        </div>
      </div>
      <Lister
        columns={columns}
        items={_filteredItems}
        mock={!loaded}
        pagination
        paginationAlwaysShowFooter
        itemsPerPage={50}
      />
    </div>
  );
};

export default Ephemerals;
